import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Select, Button, Form, Card } from 'antd'

import apiClient from '@app/apiClient'
import { fetchInspections, updateInspection } from '@app/store/reducers/inspection/inspectionSlice'
import { selectInspectionsData } from '@app/store/reducers/inspection/inspectionSelectors'

const BACKOFFICE_STATUS_OPTIONS = [
  { value: 'waiting_for_floor_plan', label: 'Waiting for Floor Plan' },
  { value: 'pending', label: 'Pending' },
  { value: 'ready_to_work', label: 'Ready to Work' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'upd_review', label: 'UPD Review' },
  { value: 'completed', label: 'Completed' },
]

const InspectionBackofficeStatus = ({ orderId }) => {
  const dispatch = useDispatch()

  const inspectionsData = useSelector(selectInspectionsData)
  const [userOptions, setUserOptions] = useState([])

  const [inspection, setInspection] = useState({})

  const [backofficeStatus, setBackofficeStatus] = useState('')
  const [rboAssigned, setRboAssigned] = useState('')

  useEffect(() => {
    if (inspectionsData.length > 0) {
      setInspection(inspectionsData[0])
      setBackofficeStatus(inspectionsData[0].backoffice_status)
      setRboAssigned(inspectionsData[0].assigned)
    }
  }, [inspectionsData])

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await apiClient(API2_URL).get('users/list', { limit: 200, skip: 0 })
        const options = (response.results || []).map((user) => ({
          label: `${user?.first_name} ${user?.last_name}`,
          value: user.id,
        }))
        setUserOptions(options)
      } catch (error) {}
    }
    fetchUsers()
  }, [])

  const onUpdate = async () => {
    const updatePayload = { backoffice_status: backofficeStatus, assigned: rboAssigned }
    const inspectionId = inspection._id

    await dispatch(
      updateInspection({
        inspectionId,
        update: updatePayload,
      }),
    )
    await dispatch(fetchInspections(orderId))
  }

  const isDisableUpdate = !(inspection?.backoffice_status !== backofficeStatus || inspection?.assigned !== rboAssigned)

  return (
    <Card size="small" title="UPD Form Filler Status">
      <Form layout="inline">
        <Form.Item label="Form Filler Status:">
          <Select
            value={backofficeStatus}
            onChange={(value) => setBackofficeStatus(value)}
            options={BACKOFFICE_STATUS_OPTIONS}
            style={{ minWidth: '150px' }}
          />
        </Form.Item>
        <Form.Item label="RBO Assigned:">
          <Select
            showSearch
            value={rboAssigned}
            onChange={(value) => setRboAssigned(value)}
            options={userOptions}
            style={{ minWidth: '200px' }}
            filterOption={(input, option) => (option?.label || '').toLowerCase().includes(input.toLowerCase())}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" disabled={isDisableUpdate} onClick={onUpdate}>
            Update
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default InspectionBackofficeStatus
